import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=45d18f98&scoped=true"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"
import style0 from "./ReportPage.vue?vue&type=style&index=0&id=45d18f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d18f98",
  null
  
)

export default component.exports